module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/step1-e5963d8725c23a7f03597684a65f2d64.png";